import React, { useEffect, useState } from 'react';
import { ButtonContainer, IntroBackground, Mention, TitleContainer } from './styles';
import { GooglePlayButton, AppStoreButton } from 'react-mobile-app-button';
import urIcon from '../../assets/images/UrLogo.png';

const IntroComponent = () => {
  const [deviceType, setDeviceType] = useState('unknown');

  useEffect(() => {
    // Function to detect the device type
    const detectDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor;

      // Check for iOS devices
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        setDeviceType('ios');
      }
      // Check for Android devices
      else if (/android/i.test(userAgent)) {
        setDeviceType('android');
      }
      // Desktop or other devices
      else {
        setDeviceType('other');
      }
    };

    detectDevice();
  }, []);

  // Render the appropriate button based on device type
  const renderAppButton = () => {
    if (deviceType === 'ios') {
      return (
        <AppStoreButton
          url={'https://apps.apple.com/kr/app/ureka-urcode-scanner/id6738121169'}
          theme={'dark'}
          className={'custom-style'}
        />
      );
    } else if (deviceType === 'android') {
      return (
        <GooglePlayButton
          url={'https://play.google.com/store/apps/details?id=com.icon.inocamx2&hl=ko'}
          theme={'dark'}
          className={'custom-style'}
        />
      );
    } else {
      // For desktop or unknown devices, show both buttons
      return (
        <>
          <div>
            <div style={{"marginBottom":"10px"}}>
              <GooglePlayButton
                url={'https://play.google.com/store/apps/details?id=com.icon.inocamx2&hl=ko'}
                theme={'dark'}
                className={'custom-style'}
              />
            </div>
            <AppStoreButton
              url={'https://apps.apple.com/kr/app/ureka-urcode-scanner/id6738121169'}
              theme={'dark'}
              className={'custom-style'}
            />
          </div>
        </>
      );
    }
  };

  return (
    <IntroBackground>
      <TitleContainer>
        <img src={urIcon} alt="urIcon" className="urLogo" />
        <Mention>UR 코드 다운로드</Mention>
      </TitleContainer>
      <ButtonContainer>{renderAppButton()}</ButtonContainer>
    </IntroBackground>
  );
};

export default IntroComponent;
